import React from 'react';
import { ShieldCheckIcon, BadgeCheckIcon, DownloadIcon, LockIcon, UsersIcon } from 'lucide-react';
export function TrustBar() {
  const items = [{
    icon: LockIcon,
    text: 'Pago 100% Seguro'
  }, {
    icon: ShieldCheckIcon,
    text: 'Garantía 45 Días'
  }, {
    icon: DownloadIcon,
    text: 'Descarga Inmediata'
  }, {
    icon: BadgeCheckIcon,
    text: 'Satisfacción Garantizada'
  }, {
    icon: UsersIcon,
    text: '+2.400 Compradores'
  }];
  return <div className="bg-[#FEF3E2] border-y border-[#E8D5C4] py-6 px-4" data-id="element-286">
      <div className="max-w-6xl mx-auto flex flex-wrap justify-center gap-6 md:gap-10" data-id="element-287">
        {items.map((item, index) => <div key={index} className="flex items-center gap-2 text-[#6B5344]" data-id="element-288">
            <item.icon className="w-5 h-5 text-[#D4850A]" data-id="element-289" />
            <span className="text-sm md:text-base font-medium" data-id="element-290">
              {item.text}
            </span>
          </div>)}
      </div>
    </div>;
}